var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scatter-legend"},[_c('svgicon',{staticClass:"scatter-legend__icon",attrs:{"name":_vm.icon,"width":"13","height":"13","original":""}}),_c('p',{staticClass:"scatter-legend__label"},[_vm._v(" "+_vm._s(_vm.text)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }